export const MIDWIFE = {
  id: 'midwife',
  label: 'Ostetrica/o',
};
export const GYNECOLOGIST = {
  id: 'gynecologist',
  label: 'Ginecologo/a',
};
export const MIDWIFE_AND_GYNECOLOGIST = {
  id: 'midwife_and_gynecologist',
  label: 'Ostetrica/o e Ginecologo/a',
};
export const GENERAL_PRACTITIONER = {
  id: 'general_practitioner',
  label: 'MMG',
};
export const NONE = {
  id: 'none',
  label: 'Nessuno',
};
export const UNKNOWN_NOT_DECLARED = {
  id: 'unknown_not_declared',
  label: 'Non noto/non dichiarato',
};
